export default __webpack_public_path__ + "static/media/poster-2.533cd712.jpg";